import { Route } from "@angular/router";
import { Platform } from "./models/platform";

export const VrijwilligerswerkPaths = {
  Vacatures: "vacatures",
};

export default [
  {
    path: VrijwilligerswerkPaths.Vacatures,
    loadComponent: () =>
      import("./pages/approved-job-list/approved-job-list.component").then(
        (c) => c.ApprovedJobListComponent
      ),
    data: {
      breadcrumb: "Overzicht vacatures",
      title: "Overzicht vacatures",
      platform: Platform.VRIJWILLIGERSWERK,
      subscriptionTypes: [1],
    },
  },
] satisfies Route[];
